export default {
  'Extract audio': 'Извлечь аудио',
  'Mute': 'Беззвучный режим',
  'Split video and audio': 'Разделить видео и аудио',
}